export var Dealness;
(function (Dealness) {
    Dealness["Fair"] = "fair";
    Dealness["Good"] = "good";
    Dealness["Great"] = "great";
    Dealness["Wait"] = "wait";
})(Dealness || (Dealness = {}));
export var RecommendationV2Enum;
(function (RecommendationV2Enum) {
    RecommendationV2Enum["Buy"] = "Buy";
    RecommendationV2Enum["Wait"] = "Wait";
    RecommendationV2Enum["BuyNeutral"] = "BuyNeutral";
    RecommendationV2Enum["WaitNeutral"] = "WaitNeutral";
})(RecommendationV2Enum || (RecommendationV2Enum = {}));
export var PriceDropProtectionEnum;
(function (PriceDropProtectionEnum) {
    PriceDropProtectionEnum["IsEligible"] = "IsEligible";
    PriceDropProtectionEnum["NotEligible"] = "NotEligible";
})(PriceDropProtectionEnum || (PriceDropProtectionEnum = {}));
export var PredictionResultEnum;
(function (PredictionResultEnum) {
    PredictionResultEnum["Prediction"] = "Prediction";
    PredictionResultEnum["UnavailablePrediction"] = "UnavailablePrediciton";
})(PredictionResultEnum || (PredictionResultEnum = {}));
export var ShopFilter;
(function (ShopFilter) {
    ShopFilter["ShortLayover"] = "ShortLayover";
    ShopFilter["NonStopNoLCC"] = "NonStopNoLCC";
    ShopFilter["NoLCC"] = "NoLCC";
    ShopFilter["NonStop"] = "NonStop";
    ShopFilter["ShortLayoverNoLCC"] = "ShortLayoverNoLCC";
    ShopFilter["NoFilter"] = "NoFilter";
})(ShopFilter || (ShopFilter = {}));
export var PushNotificationFilter;
(function (PushNotificationFilter) {
    PushNotificationFilter["EmailOnly"] = "EmailOnly";
    PushNotificationFilter["AppNotifications"] = "AppNotifications";
})(PushNotificationFilter || (PushNotificationFilter = {}));
export var Platform;
(function (Platform) {
    Platform["Desktop"] = "Desktop";
    Platform["Mobile"] = "Mobile";
    Platform["App"] = "App";
})(Platform || (Platform = {}));
//# sourceMappingURL=shop-summary.js.map